import { z } from 'zod';
import type { components } from '~~/types/Api';
import { exhaustive } from '~~/types/Exhaustive';

export type ProgrammeApplication = components['schemas']['ProgrammeApplication'];

export type ProgrammeApplicationArchive = components['schemas']['ProgrammeApplicationArchive'];

export type ProgrammeApplicationDetails = components['schemas']['ProgrammeApplicationDetails'];

export type ProgrammeApplicationEdit = components['schemas']['ApplicationEdit'];

export type ProgrammeApplicationState = components['schemas']['ProgrammeApplicationState'];

export const programmeApplicationStateSchema = z.enum(exhaustive<ProgrammeApplicationState>()([
	'Accepted',
	'Legacy',
	'OnHold',
	'Open',
	'Rejected',
	'Unknown',
]));

// IMPORTANT: These values are tightly coupled to our email service — inform the product team before changing them.
export const programmeApplicationRejectionReasonSchema = z.enum([
	'reach',
	'topic',
	'policy',
	'general',
]);

export type ProgrammeApplicationRejectionReason = z.infer<typeof programmeApplicationRejectionReasonSchema>;
